import createAxiosInstance from "./createAxiosInstance";

export default createAxiosInstance("/umbraco/forms/api/v1.0/");
